import { createFileRoute } from '@tanstack/react-router';
import { deliveryDetailQuery } from '@/api/queries/deliveries';
import { DeliveryEditorScreen } from '@/features/receiving/DeliveryScreens';
import { isFeatureUnlocked, sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/_app/receiving/$deliveryId')({
  loader: async ({ context, params }) => {
    // A chef without the stock beta gets ComingSoon from the screen, not a
    // 403 from here (and no deliveries API call at all).
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (!isFeatureUnlocked(session, 'stock')) return;
    const id = Number(params.deliveryId);
    if (!Number.isInteger(id) || id < 1) return;
    // A missing delivery is the screen's "not found", not a route error.
    await context.queryClient.ensureQueryData(deliveryDetailQuery(id)).catch(() => undefined);
  },
  component: () => {
    const { deliveryId } = Route.useParams();
    return <DeliveryEditorScreen deliveryId={Number(deliveryId)} />;
  },
});
